import React from "react";

const CardWithHeaderTemplate = ({ header, body, footer, extraCardClassName = null, extraBodyClassName = null, isHaveHeaderStyle = false, inlineCSS = null, showMy4 = true }) => {
    return (
        <div className={`card ${showMy4 ? "my-4" : ""} ${extraCardClassName != null ? extraCardClassName : ''}`}>
            {header !== null && (
                <>
                    {isHaveHeaderStyle ? header : (
                        <div className="card-header p-3 pb-0">
                            {header}
                        </div>
                    )}
                </>
            )}
            <div className={`card-body ${extraBodyClassName != null ? extraBodyClassName : 'px-0 pb-2'}`} style={inlineCSS}>
                {body}
            </div>
            {footer !== null && (
                <div className="card-footer px-0 mt-2 mb-0">
                    {footer}
                </div>
            )}
        </div>
    );
}

export default CardWithHeaderTemplate;
